import { defineGlobal } from "@faire/globals";
import { isWindowUndefined } from "@faire/globals/browser/isWindowUndefined";
import { useSyncExternalStore } from "use-sync-external-store/shim";

const _needsHydration = defineGlobal<boolean>("needsHydration", {
  escapeFaireNamespace: true,
});

let _isHydrating = _needsHydration.get(false);

/**
 * Return true during server-side rendering or client hydration.
 *
 * This returns true during client hydration because React requires that the result
 * of server-side rendering matches the initial render ("hydration") on the client.
 *
 * More information: https://www.joshwcomeau.com/react/the-perils-of-rehydration
 */
export const maybeSSR = () => isWindowUndefined() || _isHydrating;

export const handleWillHydrate = () => {
  _isHydrating = true;
};

export const HYDRATION_COMPLETED_EVENT = "faire:hydration-complete";

export const handleHydrationCompleted = () => {
  _isHydrating = false;
  if (!isWindowUndefined()) {
    window.dispatchEvent(new Event(HYDRATION_COMPLETED_EVENT));
  }
};

/**
 * Hook that returns true during SSR and hydration.
 */
export const useIsSSR = (): boolean => {
  return useSyncExternalStore(
    // The value never changes, no need to subscribe.
    () => () => {},
    // Called during client rendering
    maybeSSR,
    // During hydration, we need to match SSR.
    () => true
  );
};
